<template>
  <div>
    <div class="topNav">
      <div class="search_input">
        <el-input placeholder="请输入名称、编号" v-model="queryInfo.value" clearable @change="searchChange" @input="input">
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
            @click="searchChange"
          />
        </el-input>
      </div>
      <!-- 更多筛选 -->
      <div class="moreScreen">
        <div class="more">
          <more-screen :edit-flag="editFlag" :state="state" @searchJson="searchJsonList" :search="search" :tab-type="tabType" />
        </div>
      </div>
      <!-- 排序 -->
      <div class="rank" @click="rank = true" v-if="state !== 'manhour'">
        <rank :state="state" @orderJson="orderJsonList" :sorting="sorting" />
      </div>
    </div>
  </div>
</template>

<script>
import moreScreen from './moreSarch.vue'
import rank from './rank.vue'
export default {
  components: { moreScreen, rank },
  props: {
    // 接受 参数
    state: {
      type: String,
      default: ''
    },
    // 筛选
    searching: {
      type: Array,
      default: () => ([])
    },
    // 筛选
    queryInfo: {
      type: Object,
      default: () => ({})
    },
    // 排序
    sorting: {
      type: Array,
      default: () => ([])
    },
    tab: {
      type: String,
      default: ''
    },
    tabType: {
      type: String,
      default: ''
    },
    tabsDate: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      searchList: [],
      search: [],
      editFlag: true
    }
  },
  watch: {
    searching: {
      handler() {
        this.search = this.searching
        this.searchList = this.searching
        sessionStorage.setItem('queryInfos', JSON.stringify(this.searching))
      }
    },
    queryInfo: {
      handler() {
      }
    },
    sorting: {
      handler() {
      }
    }
  },
  mounted() {
    this.height = this.clientHeights - 340
    console.log(this.height)
    const that = this
    window.onresize = () =>
      (() => {
        that.height = document.documentElement.clientHeight - 340
        console.log(that.height)
      })()
  },
  methods: {
    input(input) {
      console.log(input)
    },
    // 搜索
    searchChange() {
      this.$emit('searchJson', this.searchList, this.queryInfo)
    },
    // 筛选
    searchJsonList(date) {
      this.searchList = date
      this.searchChange()
    },
    // 排序
    orderJsonList(date) {
      this.$emit('orderJson', date)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/index.scss";
.topNav {
  display: flex;
  // padding: 0 40px;
}
.search_input {
  margin-right: 20px;
  height: 36px !important;
  .el-input {
    height: 36px;
    width: 223px;
    border-radius: 4px;
    margin: 20px 0;
  }
  ::v-deep .el-input--prefix .el-input__inner{
    height: 36px;
    line-height: 36px;
  }
}
::v-deep .el-input--prefix .el-input__innerZ{
  height: 36px;
  line-height: 36px;
}
.el-input__icon{
  font-size: 18px;
  line-height: 36px;
}
.iconfont {
  padding-right: 5px;
  font-size: $font_14;
}
.more,.rank{
  margin: 20px 10px;
}
</style>
